import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const buildOwnerTransactionFilename = (transaction) => {
  const docType = String(transaction?.short_desc || transaction?.trans_type || 'Owner Transaction')
    .replace(/[^a-z0-9]+/gi, '')
    || 'OwnerTransaction';
  const ownerCode = String(transaction?.owner_code || 'owner').replace(/[^a-z0-9_-]+/gi, '_');
  const idParts = String(transaction?.id || 'owner-transaction').split(':');
  const docId = idParts.length >= 3 ? `${idParts[0]}${idParts[2]}` : String(transaction?.id || 'owner-transaction').replace(/[:\s]+/g, '');
  const datePart = transaction?.date ? new Date(transaction.date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
  return `${docType}_${ownerCode}_${docId}_${datePart}.pdf`;
};

export const generateOwnerTransactionPdf = async () => {
  const printElement = document.getElementById('owner-transaction-print-sheet');

  if (!printElement) {
    throw new Error('Owner transaction print sheet not found');
  }

  await new Promise((resolve) => setTimeout(resolve, 350));

  const cloneHost = document.createElement('div');
  cloneHost.setAttribute('aria-hidden', 'true');
  cloneHost.style.position = 'fixed';
  cloneHost.style.left = '-10000px';
  cloneHost.style.top = '0';
  cloneHost.style.width = `${printElement.scrollWidth}px`;
  cloneHost.style.pointerEvents = 'none';
  cloneHost.style.overflow = 'hidden';
  cloneHost.style.background = '#ffffff';

  const clone = printElement.cloneNode(true);
  clone.style.zoom = '1';
  clone.style.transform = 'none';
  clone.style.margin = '0';
  clone.style.maxWidth = 'none';
  clone.style.width = '210mm';

  cloneHost.appendChild(clone);
  document.body.appendChild(cloneHost);

  const pageNodes = Array.from(clone.querySelectorAll('.owner-transaction-pdf-page'));
  let canvases = [];
  try {
    if (pageNodes.length > 0) {
      for (const pageNode of pageNodes) {
        // eslint-disable-next-line no-await-in-loop
        const canvas = await html2canvas(pageNode, {
          scale: 2,
          useCORS: true,
          logging: false,
          backgroundColor: '#ffffff',
          width: pageNode.scrollWidth,
          height: pageNode.scrollHeight,
          windowWidth: pageNode.scrollWidth,
          windowHeight: pageNode.scrollHeight
        });
        canvases.push(canvas);
      }
    } else {
      canvases = [await html2canvas(clone, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
        width: clone.scrollWidth,
        height: clone.scrollHeight,
        windowWidth: clone.scrollWidth,
        windowHeight: clone.scrollHeight
      })];
    }
  } finally {
    document.body.removeChild(cloneHost);
  }

  const pdf = new jsPDF('p', 'mm', 'a4');
  const imgWidth = 210;

  canvases.forEach((canvas, index) => {
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const imgData = canvas.toDataURL('image/png', 1.0);

    if (index > 0) {
      pdf.addPage();
    }

    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  }
  );

  return pdf;
};
